import { WorkSpace } from "@/core/entities/workspace";
import { IWorkSpaceRepository } from "@/core/repositories/workspace";
import { WorkSpaceContext } from "@/infrastructure/context";

/**
 * This is a use case that gets the workspace.
 * @example
 * const workSpace = await new GetWorkSpaceUseCase(new WorkSpaceRepository()).execute();
 */
export class GetWorkSpaceUseCase {
  constructor(private readonly workspaceRepository: IWorkSpaceRepository) {}

  async execute(): Promise<WorkSpace | null> {
    const workSpace = await this.workspaceRepository.getWorkspace();
    WorkSpaceContext.getInstance().setWorkSpace(workSpace);
    return workSpace;
  }
}
